module.exports = __webpack_public_path__ + "static/img/hzhb7.865954a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb7.png
// module id = uvPT
// module chunks = 0